/* eslint-disable react/style-prop-object */
import React, { useContext, useEffect, useState, useMemo } from "react";
import { useSelector } from "react-redux";
import Searchbar from "../../Helpers/Searchbar/Searchbar";
import ReportsSidebarRows from "./ReportsSidebarRows/ReportsSidebarRows";
import ReportDefinitionHead from "./ReportTypesDefinition/ReportDefinitionHead";
import Table from "../../Helpers/Table/Table";
import { reportsDataMap } from "./ReportsTypesData/ReportsTypesData";
import { filtrationcontext } from "../../../context/Filtercontext";
import trans from "../../../utils";
import { exportContext } from "../../../context/ExportDataContext";
import usePermission from "../../../hooks/usePermission";
import { useGetClientReportsQuery } from "../../../Redux/service/Analytics/Analytics";

export default function ReportTypes() {
	const [active, setActive] = useState("vehicle");
	const [type, setType] = useState("vehicle");
	const HeadField = [trans("Name"), trans("Description"), trans("ReportType")];
	const { setSearchQuery } = useContext(filtrationcontext);
	const [query, setQuery] = useState("");

	// Get permissions for parent modules
	const vehiclesPermission = usePermission("REPORTS");
	const fsPermission = usePermission("REPORTSFS");
	const inventoryPermission = usePermission("REPORTSINVENTORY");
	const reportsPermission = usePermission("REPORTS");
	const allReportsPermission = usePermission("ALLREPORTS");
	const clientReportsPermission = usePermission("CLIENTREPORTS");

	// Get user permissions directly from Redux
	const user = useSelector((state) => state.users.auth);
	const permissions = user?.permissions || [];

	const canViewClientReports =
		reportsPermission?.view || allReportsPermission?.view || clientReportsPermission?.view;

	const { data: clientReportsRes } = useGetClientReportsQuery(undefined, {
		skip: !canViewClientReports,
	});

	const handleSearch = (e) => {
		setQuery(e.target.value);
		setSearchQuery(e.target.value);
	};
	const { setFileName, setExportIds, setStartDateE, setEndDateE } =
		useContext(exportContext);

	const clientReports = useMemo(() => {
		const reports = clientReportsRes?.data || [];
		return reports.map((report) => ({
			name: report.name,
			shortname: report.id,
			description: trans("Saved analytics report"),
			reportType: "client",
		}));
	}, [clientReportsRes]);

	// Filter reports based on permissions
	const filteredReportsDataMap = useMemo(() => {
		const filtered = {};

		Object.keys(reportsDataMap).forEach((category) => {
			const reports = reportsDataMap[category];
			const filteredReports = reports.filter((report) => {
				// If report has a moduleKey, check permission for it
				if (report.moduleKey) {
					const modulePermission = permissions.find(
						(perm) => perm.moduleKey === report.moduleKey
					);
					return modulePermission?.actions?.view || false;
				}
				// If no moduleKey, show by default (for backwards compatibility)
				return true;
			});

			filtered[category] = filteredReports;
		});

		filtered.client = clientReports;
		return filtered;
	}, [permissions, clientReports]);

	// Determine which categories should be visible
	const shouldShowVehicles =
		vehiclesPermission.view && filteredReportsDataMap.vehicle?.length > 0;
	const shouldShowFieldServices =
		fsPermission.view && filteredReportsDataMap.fieldservices?.length > 0;
	const shouldShowInventory =
		(inventoryPermission.view || filteredReportsDataMap.inventory?.length > 0) &&
		filteredReportsDataMap.inventory?.length > 0;
	const shouldShowClientReports =
		canViewClientReports && filteredReportsDataMap.client?.length > 0;

	// Set initial active tab based on available permissions
	useEffect(() => {
		if (shouldShowVehicles) {
			setActive("vehicle");
			setType("vehicle");
		} else if (shouldShowFieldServices) {
			setActive("fieldservices");
			setType("fieldservices");
		} else if (shouldShowInventory) {
			setActive("inventory");
			setType("inventory");
		} else if (shouldShowClientReports) {
			setActive("client");
			setType("client");
		}
	}, [shouldShowVehicles, shouldShowFieldServices, shouldShowInventory, shouldShowClientReports]);

	useEffect(() => {
		return () => setSearchQuery("");
	}, [setSearchQuery]);
	useEffect(() => {
		return () => setSearchQuery("");
	}, [setSearchQuery]);

	useEffect(() => {
		return () => {
			setFileName("");
			setExportIds([]);
			setStartDateE(null);
			setEndDateE(null);
		};
	}, []);
	useEffect(() => {
		return () => {
			setFileName("");
			setExportIds([]);
			setStartDateE(null);
			setEndDateE(null);
		};
	}, []);

	return (
		<>
			<div className="row gx-0">
				<div className="col-lg-2">
					<div className="reports-sidebar-types">
						<Searchbar
							style="search-dark input-group"
							path={`${process.env.PUBLIC_URL}/assets/Search.svg`}
							placeholder={trans("Search Report Name...")}
							value={query}
							width={"183px"}
							onChange={handleSearch}
						/>
						<div className="reports-sidebar-types-title">
							{trans("report types")}
						</div>
						{shouldShowVehicles && (
							<ReportsSidebarRows
								name={trans("Vehicles")}
								filterType="vehicle"
								icon="vehicle"
								active={active}
								setActive={setActive}
								setType={setType}
							/>
						)}
						{shouldShowFieldServices && (
							<ReportsSidebarRows
								name={trans("field services")}
								filterType="fieldservices"
								icon="fieldservices"
								active={active}
								setActive={setActive}
								setType={setType} /*  */
							/>
						)}
						{shouldShowInventory && (
							<ReportsSidebarRows
								name={trans("Inventory")}
								filterType="inventory"
								icon="fieldservices"
								active={active}
								setActive={setActive}
								setType={setType}
							/>
						)}
						{shouldShowClientReports && (
							<ReportsSidebarRows
								name={trans("Client Reports")}
								filterType="client"
								icon="fieldservices"
								active={active}
								setActive={setActive}
								setType={setType}
							/>
						)}
					</div>
				</div>
				<div className="col-lg-10 reports-types-definition">
					<ReportDefinitionHead
						name={trans(filteredReportsDataMap[type]?.[0]?.reportType) || trans("Client Reports")}
						type={type}
					/>
					<Table
						HeadField={HeadField}
						BodyData={filteredReportsDataMap[type] || []}
						type="reportstypes"
					/>
				</div>
			</div>
		</>
	);
}
